<template>
  <div>
    <div class="download__page">
      <!-- 顶部设备tab -->
      <div class="download__device">
        <a
          v-for="(item, i) in deviceList"
          :key="i"
          :class="['device', item.name === activeDevice ? 'active' : '']"
          @click="clickToChangeTab(item)"
        >
          <i :class="item.className"></i>
          <p class="device__name">{{ item.name }}</p>
        </a>
      </div>

      <!-- 图片 + 下载部分 -->
      <div class="download__content">
        <!-- 图片 -->
        <div class="download__present">
          <img
            :src="(isWin || isMac) ? require('@assets/d/presentPc.png') : require('@assets/d/presentApp.png')"
            alt=""
            class="download__present-img"
            height="328"
            width="543">
        </div>
        <!-- 下载 -->
        <div class="download__client">
          <template>
            <img alt="受益一生的能力"
                 class="client__title"
                 height="52"
                 src="https://static1.xesimg.com/quality-mall/download/longgui1115.png"
                 width="415">
            <!-- pc/mac -->
            <div v-if="isWin || isMac" class="client__box client__box-pc">
              <h3 class="client__box-h3">{{ activeDevice }}客户端</h3>
              <p class="client__box-tips">{{ isMac ? alert2 : alert1 }}</p>
              <p class="client__box-tips">
                <span>版本：{{ isMac ? macVersion : winVersion }}</span>
                <template v-if="isMac">
                  <span v-if="macUpdateTime">更新时间：{{ macUpdateTime }}</span>
                </template>
                <template v-else>
                  <span v-if="winUpdateTime">更新时间：{{ winUpdateTime }}</span>
                </template>
              </p>
              <a class="download__btn" @click="handleDownload">立即下载</a>
            </div>
            <!-- 移动端 -->
            <div v-else class="client__box client__box-app">
              <img alt="" height="134" src="@assets/d/iphoneDown.png" width="134" />
              <div class="client__content">
                <h3 class="client__box-h3">{{ activeDevice }}客户端</h3>
                <p class="client__box-tips">用手机扫描二维码</p>
                <p class="client__box-version">
                  <span>版本：{{ isAndroid ? androidVersion : iosVersion }}</span>
                  <template v-if="isAndroid">
                    <span v-if="androidUpdateTime">更新时间：{{ androidUpdateTime }}</span>
                  </template>
                  <template v-else>
                    <span v-if="iosUpdateTime">更新时间：{{ iosUpdateTime }}</span>
                  </template>
                </p>
              </div>
            </div>
          </template>
          <!-- 设备说明 -->
          <div v-if="!isWin && !isMac" class="client__description">
            <template v-if="isAndroid">
              设备支持：6.0及以上系统版本，2GB及以上运行内存
            </template>
            <template v-else>
              设备支持：i0S12.0及以上系统版本。以下设备支持，但可能会影响上课体验：iPhone 6/Plus、iPhone 6s/Plus、iPhone 7/Plus、iPhone SE、iPad Air、iPad Air2、iPad mini2、iPad mini3、iPad mini4
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $confirm from '@components/confirm'
import request from '@request'

const detectOS = function () {
  var sUserAgent = navigator.userAgent
  var isWin =
    navigator.platform === 'Win32' ||
    navigator.platform === 'Win64' ||
    navigator.platform === 'Windows'
  var isMac =
    navigator.platform === 'Mac68K' ||
    navigator.platform === 'MacPPC' ||
    navigator.platform === 'Macintosh' ||
    navigator.platform === 'MacIntel'
  if (isMac) return 'Mac'
  var isUnix = navigator.platform === 'X11' && !isWin && !isMac
  if (isUnix) return 'Unix'
  var isLinux = String(navigator.platform).indexOf('Linux') > -1
  var bIsAndroid = sUserAgent.toLowerCase().match(/android/i) === 'android'
  if (isLinux) {
    if (bIsAndroid) return 'Android'
    else return 'Linux'
  }
  if (isWin) {
    var isWin2K =
      sUserAgent.indexOf('Windows NT 5.0') > -1 || sUserAgent.indexOf('Windows 2000') > -1
    if (isWin2K) return 'Win2000'
    var isWinXP =
      sUserAgent.indexOf('Windows NT 5.1') > -1 || sUserAgent.indexOf('Windows XP') > -1
    if (isWinXP) return 'WinXP'
    var isWin2003 =
      sUserAgent.indexOf('Windows NT 5.2') > -1 || sUserAgent.indexOf('Windows 2003') > -1
    if (isWin2003) return 'Win2003'
    var isWinVista =
      sUserAgent.indexOf('Windows NT 6.0') > -1 ||
      sUserAgent.indexOf('Windows Vista') > -1
    if (isWinVista) return 'WinVista'
    var isWin7 =
      sUserAgent.indexOf('Windows NT 6.1') > -1 || sUserAgent.indexOf('Windows 7') > -1
    if (isWin7) return 'Win7'
    var isWin8 =
      sUserAgent.indexOf('Windows NT 6.2') > -1 || sUserAgent.indexOf('Windows 8') > -1
    if (isWin8) return 'Win8'
    var isWin81 =
      sUserAgent.indexOf('Windows NT 6.3') > -1 || sUserAgent.indexOf('Windows 8.1') > -1
    if (isWin81) return 'Win81'
    var isWin10 =
      sUserAgent.indexOf('Windows NT 10.0') > -1 || sUserAgent.indexOf('Windows 10') > -1
    if (isWin10) return 'Win10'
  }

  return 'other'
}

const formatDate = function (time) {
  if (!time) return ''
  const date = time.split(' ')[0]
  const dateArr = date.split('-')

  return `${dateArr[0]}年${dateArr[1]}月${dateArr[2]}日`
}

export default {
  data() {
    return {
      operatingSystem: null,
      activeDevice: 'Windows',
      deviceList: [
        {
          name: 'Windows',
          className: 'icon-win'
        },
        {
          name: 'Mac',
          className: 'icon-mac'
        },
        {
          name: 'Android',
          className: 'icon-android'
        },
        {
          name: 'iPhone/iPad',
          className: 'icon-ios'
        }
      ],
      str: null,
      ver: null,
      n1: null,
      n2: null,
      winVersion: '5.1.0',
      macVersion: '5.1.0',
      androidVersion: '9.51.01',
      iosVersion: '9.50.02',
      alert1: '请使用Win7及以上系统 推荐硬件：处理器i3以上，内存4G以上',
      alert2: '适用于Mac电脑操作系统版本不低于10.12',
      dateTime: null,
      winUpdateTime: '2022-06-17 18:24:28', // 更新时间
      macUpdateTime: '2022-06-21 20:28:53',
      androidUpdateTime: '2022-06-20 13:59:35',
      iosUpdateTime: '2022-06-06 09:49:52',
      macRootPath: 'student/literacy/mac/5.1.0/75/xes_literacy_mac_v5.1.0.pkg',
      winRootPath: 'student/literacy/win/5.1.0/62/xes_literacy_win_v5.1.0.exe',
      domainArr: ['https://liveclient.xesimg.com'],
      domainIndex: 0
    }
  },
  computed: {
    isWin() {
      return this.activeDevice === 'Windows'
    },
    isMac() {
      return this.activeDevice === 'Mac'
    },
    isAndroid() {
      return this.activeDevice === 'Android'
    }
  },
  mounted() {
    this.$xesLogger.cacheUploader({
        key: 'xes-mall-download',
        showid: 'show_NK4LjxmN',
        eventname: '下载客户端-曝光'
    }, 'a', 'pv');

    this.getDownloadVersion()
    this.$eventBus.$emit('RouterPageMounted', this.$route.name)
  },
  methods: {
    async getDownloadVersion() {
      this.dateTime = new Date().getTime()
      this.entry = this.getQueryString('entry')
      try {
        const res = await request.get('https://mall.xueersi.com/download-version')
        const { result: { data } } = res
        this.winVersion = data.winVersion || this.winVersion
        this.macVersion = data.macVersion || this.macVersion
        this.androidVersion = data.androidVersion || this.androidVersion
        this.iosVersion = data.iosVersion || this.iosVersion

        this.winUpdateTime = formatDate(data.winUpdateTime) || this.winUpdateTime
        this.macUpdateTime = formatDate(data.macUpdateTime) || this.macUpdateTime
        this.androidUpdateTime = formatDate(data.androidUpdateTime) || this.androidUpdateTime
        this.iosUpdateTime = formatDate(data.iosUpdateTime) || this.iosUpdateTime

        this.macRootPath = data.macRootPath || this.macRootPath
        this.winRootPath = data.winRootPath || this.winRootPath
        this.domainArr = data.domain || this.domainArr
      } catch (error) {
        console.log('error', error)
      }
      this.operatingSystem = detectOS()
      this.activeDevice = this.operatingSystem === 'Mac' ? 'Mac' : 'Windows'
      this.$xesLogger.cacheUploader({
        params: {
          key: 'xes-mall-download',
          clickid: '1.1',
          device: this.activeDevice
        }
      }, 'b', 'pv');
      // 判断用户是mac系统并且系统版本大于等于10
      if (this.operatingSystem === 'Mac') {
        // 判断macos系统版本
        this.str = navigator.userAgent.toLowerCase()
        this.ver =
          // eslint-disable-next-line no-useless-escape
          this.str.match(/(\d+)\_(\d+)/) || this.str.match(/intel mac os x (\d+)\.(\d+)/)
        this.n1 = Number(this.ver[1])
        this.n2 = Number(this.ver[2])
      }
    },
    clickToChangeTab(item) {
      this.activeDevice = item.name
      this.$xesLogger.cacheUploader({
        params: {
          key: 'xes-mall-download',
          clickid: '1.0',
          device: item.name
        }
      }, 'b', 'click');
      this.$xesLogger.cacheUploader({
        params: {
          key: 'xes-mall-download',
          clickid: '1.1',
          device: item.name
        }
      }, 'b', 'pv');
    },
    handleDownload() {
      const len = this.domainArr.length
      const domain = this.domainArr[this.domainIndex]
      // 当前选中mac
      if (this.isMac) {
        if (this.operatingSystem === 'Mac' &&
          !((this.n1 === 10 && this.n2 > 11) || this.n1 > 10)
        ) {
          this.showAlertDialog(this.alert2)
          return
        }
        const href = `${domain}/${this.macRootPath}?time=${this.dateTime}&filename=.dmg`
        this.domainIndex = Math.floor(Math.random() * len)
        window.location.href = href
        this.$xesLogger.cacheUploader({
          params: {
            key: 'xes-mall-download',
            clickid: '1.2',
            device: 'Mac'
          }
        }, 'b', 'click');
        return
      }
      // 当前选中windows
      if (this.isWin) {
        if (
          this.operatingSystem !== 'Mac' &&
          !(this.operatingSystem === 'Win10' ||
            this.operatingSystem === 'Win81' ||
            this.operatingSystem === 'Win8' ||
            this.operatingSystem === 'WinVista' ||
            this.operatingSystem === 'Win7')
        ) {
          this.showAlertDialog(this.alert1)
          return
        }
        const href = `${domain}/${this.winRootPath}?time=${this.dateTime}&filename=.exe`
        // this.domainIndex = (this.domainIndex + 1) % len
        this.domainIndex = Math.floor(Math.random() * len)
        window.location.href = href
        this.$xesLogger.cacheUploader({
          params: {
            key: 'xes-mall-download',
            clickid: '1.2',
            device: 'Windows'
          }
        }, 'b', 'click');

      }
    },
    async showAlertDialog(message) {
      $confirm({ message })
    },
    getQueryString(name) {
      const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`)
      const r = window.location.search.substr(1).match(reg)
      if (r != null) {
        return unescape(r[2])
      }
      return null
    },
  }
}
</script>


<style lang="scss">
.download__page {
  min-height: 100%;
  background-color: #ffffff;

  .download__device {
    margin: auto;
    padding-top: 32px;
    width: 800px;
    height: 91px;
    text-align: center;
    font-size: 0;
    // font-size: 13px;
    .device {
      float: left;
      width: 200px;
      color: #A5A5A5;
      cursor: pointer;

      &:hover {
        color: #E02727;

        .icon-win {
          background: url('../assets/d/icon_win_active.png') no-repeat;
          background-size: 100% 100%;
        }

        .icon-mac {
          background: url('../assets/d/icon_mac_active.png') no-repeat;
          background-size: 100% 100%;
        }

        .icon-android {
          background: url('../assets/d/icon_android_active.png') no-repeat;
          background-size: 100% 100%;
        }

        .icon-ios {
          background: url('../assets/d/icon_ios_active.png') no-repeat;
          background-size: 100% 100%;
        }
      }

      .icon-win {
        display: inline-block;
        width: 35px;
        height: 35px;
        background: url('../assets/d/icon_win.png') no-repeat;
        background-size: 100% 100%;
      }

      .icon-mac {
        display: inline-block;
        width: 42px;
        height: 35px;
        background: url('../assets/d/icon_mac.png') no-repeat;
        background-size: 100% 100%;
      }

      .icon-android {
        display: inline-block;
        width: 32px;
        height: 38px;
        background: url('../assets/d/icon_android.png') no-repeat;
        background-size: 100% 100%;
      }

      .icon-ios {
        display: inline-block;
        width: 32px;
        height: 39px;
        background: url('../assets/d/icon_ios.png') no-repeat;
        background-size: 100% 100%;
      }

      .device__name {
        margin: 12px 0 0;
        font-size: 13px;
        line-height: 1;
      }
    }

    .active {
      color: #E02727;

      .icon-win {
        background: url('../assets/d/icon_win_active.png') no-repeat;
        background-size: 100% 100%;
      }

      .icon-mac {
        background: url('../assets/d/icon_mac_active.png') no-repeat;
        background-size: 100% 100%;
      }

      .icon-android {
        background: url('../assets/d/icon_android_active.png') no-repeat;
        background-size: 100% 100%;
      }

      .icon-ios {
        background: url('../assets/d/icon_ios_active.png') no-repeat;
        background-size: 100% 100%;
      }
    }
  }

  .download__content {
    // min-width: 1200px;
    display: flex;
    justify-content: center;
    // align-items: center;
    width: 100%;
    min-height: 450px;
    padding-top: 139px;
    overflow-x: hidden;

    .download__present {
      width: 543px;
      height: 328px;
      margin-right: 70px;
      position: relative;
      top: -23px;

      &::before {
        display: inline-block;
        content: '';
        width: 415px;
        height: 295px;
        position: absolute;
        left: -189px;
        top: 30px;
        background: url('../assets/d/bg1.png') no-repeat;
        background-size: 100% 100%;
      }

      .download__present-img {
        position: relative;
        z-index: 2;
      }

      &::after {
        display: inline-block;
        content: '';
        width: 174px;
        height: 60px;
        position: absolute;
        left: -143px;
        top: -84px;
        background: url('../assets/d/circle1.png') no-repeat;
        background-size: 100% 100%;
      }
    }

    .download__client {
      position: relative;
      width: 474px;
      height: 328px;

      &::before {
        display: inline-block;
        content: '';
        width: 546px;
        height: 360px;
        position: absolute;
        right: 0;
        top: 0;
        background: url('../assets/d/bg2.png') no-repeat;
        background-size: 100% 100%;
      }

      .client__title {
        position: relative;
        z-index: 2;
      }

      &::after {
        display: inline-block;
        content: '';
        width: 196px;
        height: 80px;
        position: absolute;
        right: -171px;
        bottom: 9px;
        background: url('../assets/d/circle2.png') no-repeat;
        background-size: 100% 100%;
      }

      .client__box {
        position: relative;

        .client__box-h3 {
          margin: 27px 0 0;
          font-size: 40px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
          line-height: 48px;
        }

        .client__box-tips {
          margin: 8px 0 0;
          white-space: nowrap;
        }
      }

      .client__box-pc {
        font-size: 15px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #999999;
        line-height: 15px;
        z-index: 2;

        .download__btn {
          display: inline-block;
          width: 300px;
          height: 52px;
          line-height: 52px;
          margin-top: 24px;
          cursor: pointer;
          text-align: center;
          background-color: #E02727;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          text-decoration-line: none;

          &::before {
            display: inline-block;
            content: '';
            width: 20px;
            height: 18px;
            background: url('../assets/d/download.png') no-repeat;
            background-size: 100% 100%;
            margin-right: 12px;
            position: relative;
            top: 3px;
          }
        }
      }

      .client__box-app {
        margin-top: 27px;
        display: flex;

        .client__content {
          margin-top: 6px;
          margin-left: 19px;
          font-size: 15px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #999999;
          line-height: 15px;
          white-space: nowrap;

          .client__box-h3 {
            margin-top: 0;
          }

          .client__box-tips {
            margin: 25px 0 0;
          }

          .client__box-version {
            margin: 8px 0 0;
          }
        }
      }

      .client__description {
        color: #999999;
        font-size: 12px;
        margin-top: 21px;
        margin-left: 3px;
      }
    }
  }
}
</style>
